import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import {
  GOLDEN_RATIO_BOTTOM_FLEX,
  GOLDEN_RATIO_TOP_FLEX,
} from "@src/appV2/redesign/utils/goldenRatioLayout";

interface ShiftCancelHeaderProps {
  isWorkerRestricted?: boolean;
  isZeroPointsCancellation?: boolean;
  verticallyCenter?: boolean;
}

function getSubtitle(props: {
  isWorkerRestricted?: boolean;
  isZeroPointsCancellation?: boolean;
}): string {
  const { isWorkerRestricted, isZeroPointsCancellation } = props;

  if (isWorkerRestricted) {
    return "Showing up helps you remain in good standing with the workplace who has invited you!";
  }

  if (isZeroPointsCancellation) {
    return "This won't affect your Clipboard Score";
  }

  return "How this will impact your Clipboard Score";
}

export function ShiftCancelHeader(props: ShiftCancelHeaderProps): JSX.Element {
  const { isWorkerRestricted, isZeroPointsCancellation, verticallyCenter } = props;

  const subtitle = getSubtitle({
    isWorkerRestricted,
    isZeroPointsCancellation,
  });

  return (
    <Stack
      sx={{
        flexGrow: verticallyCenter ? 1 : 0,
      }}
    >
      {verticallyCenter && <Box sx={{ flex: GOLDEN_RATIO_TOP_FLEX, minHeight: 0 }} />}

      <Stack
        spacing={2}
        alignItems="center"
        sx={{
          paddingTop: verticallyCenter ? 2 : 12,
          paddingBottom: verticallyCenter ? 0 : 6,
          paddingX: 6,
        }}
      >
        <Text
          variant="h2"
          color={(theme) => theme.palette.intent?.error.text}
          sx={{ textAlign: "center" }}
        >
          Cancel your shift?
        </Text>
        <Text
          variant="h6"
          color={(theme) => theme.palette.text.secondary}
          sx={{ textAlign: "center" }}
        >
          {subtitle}
        </Text>
      </Stack>

      {verticallyCenter && <Box sx={{ flex: GOLDEN_RATIO_BOTTOM_FLEX, minHeight: 0 }} />}
    </Stack>
  );
}
